<template>
  <v-dialog
    v-model="dialog"
    scrollable
    max-width="900"
  >
    <privacy-dialog-component>
      <template v-slot:actions>
        <v-card-actions class="pa-3 justify-center">
          <v-btn
            color="primary"
            @click="close"
          >
            OK
          </v-btn>
        </v-card-actions>
      </template>
    </privacy-dialog-component>
  </v-dialog>
</template>

<script>

  import PrivacyDialogComponent from '@/views/anonymousPages/components/PrivacyDialogComponent'

  export default {
    name: 'PrivacyDialog',
    components: {
      PrivacyDialogComponent,
    },
    data () {
      return {
        dialog: false,
      }
    },
    methods: {
      open () {
        this.dialog = true
      },
      close () {
        this.dialog = false
      },
    },
  }
</script>
